import GetAllResourceEntriesInteractor from "../../../core/interactor/app/crud/GetResourceEntriesInteractor";
import Constants from "../../common/Constants";
import { IAttachment } from "../../model/Attachment";
import AttachmentMapper from "../../service/AttachmentMapper";
import AttachmentParamMapper from "../../service/AttachmentParamMapper";

export default class GetAllCaseLawDocumentAttachmentsInteractor {
  private resource: GetAllResourceEntriesInteractor<IAttachment>;

  constructor({ getAllResourceEntries }: any) {
    this.resource = getAllResourceEntries;
  }

  async execute(caseLawDocumentId: number) {
    return this.resource.execute(
      `${Constants.endpointBasePath}/${caseLawDocumentId}/${Constants.attachmentPath}`,
      AttachmentMapper,
      AttachmentParamMapper
    );
  }
}
